import React from "react";

const CoursePagination = ({
  course,
  activeModule,
  activePage,
  setActiveModule,
  setActivePage,
  setShowOverview,
  setSidebarCollapsed,
  setShowModulePages,
}) => {
  if (!course || !activeModule || !activePage) return null;

  const moduleKeys = Object.keys(course.modules);
  const currentModuleIndex = moduleKeys.indexOf(activeModule);
  const currentModule = course.modules[activeModule];
  const pageKeys = Object.keys(currentModule.pages);
  const currentPageIndex = pageKeys.indexOf(activePage);

  const goToPage = (moduleId, pageId) => {
    setActiveModule(moduleId);
    setActivePage(pageId);
    setShowOverview(false);
    setSidebarCollapsed(true);
    setShowModulePages(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrev = () => {
    if (currentPageIndex > 0) {
      goToPage(activeModule, pageKeys[currentPageIndex - 1]);
    } else if (currentModuleIndex > 0) {
      const prevModuleId = moduleKeys[currentModuleIndex - 1];
      const prevModulePages = Object.keys(course.modules[prevModuleId].pages);
      const lastPageId = prevModulePages[prevModulePages.length - 1];
      goToPage(prevModuleId, lastPageId);
    }
  };

  const handleNext = () => {
    if (currentPageIndex < pageKeys.length - 1) {
      goToPage(activeModule, pageKeys[currentPageIndex + 1]);
    } else if (currentModuleIndex < moduleKeys.length - 1) {
      const nextModuleId = moduleKeys[currentModuleIndex + 1];
      const nextModulePages = Object.keys(course.modules[nextModuleId].pages);
      const firstPageId = nextModulePages[0];
      goToPage(nextModuleId, firstPageId);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between gap-2 sm:gap-3 mt-4">
      {currentPageIndex === 0 && currentModuleIndex > 0 ? (
        <button 
          onClick={handlePrev}
          className="px-3 py-1.5 text-sm bg-white text-green-600 border border-green-600 rounded hover:bg-green-600 hover:text-white transition-colors"
        >
          ← Предыдущий модуль
        </button>
      ) : (
        <button
          onClick={handlePrev}
          disabled={currentPageIndex === 0 && currentModuleIndex === 0}
          className={`px-3 py-1.5 text-sm rounded transition-colors ${
            currentPageIndex === 0 && currentModuleIndex === 0
              ? 'bg-gray-300 text-gray-500 border border-gray-300 cursor-not-allowed'
              : 'bg-white text-green-600 border border-green-600 hover:bg-green-600 hover:text-white'
          }`}
        >
          ‹ Пред
        </button>
      )}

      {currentPageIndex === pageKeys.length - 1 &&
      currentModuleIndex < moduleKeys.length - 1 ? (
        <button 
          onClick={handleNext}
          className="px-3 py-1.5 text-sm bg-white text-green-600 border border-green-600 rounded hover:bg-green-600 hover:text-white transition-colors"
        >
          Следующий модуль →
        </button>
      ) : (
        <button
          onClick={handleNext}
          disabled={
            currentPageIndex === pageKeys.length - 1 &&
            currentModuleIndex === moduleKeys.length - 1
          }
          className={`px-3 py-1.5 text-sm rounded transition-colors ${
            currentPageIndex === pageKeys.length - 1 &&
            currentModuleIndex === moduleKeys.length - 1
              ? 'bg-gray-300 text-gray-500 border border-gray-300 cursor-not-allowed'
              : 'bg-white text-green-600 border border-green-600 hover:bg-green-600 hover:text-white'
          }`}
        >
          След ›
        </button>
      )}
    </div>
  );
};

export default CoursePagination;